module.exports = __webpack_public_path__ + "img/houselogo.04f6ad78.png";